import '@speeki/frontend-sentry/instrument';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { AppInitializer } from './App/AppInitializer';
import { reportWebVitals } from './reportWebVitals';

import { checkIfTeams } from '@utils/helpers';

import '@services/TranslationsService/i18n';

import { app } from '@microsoft/teams-js';

checkIfTeams() && app.initialize();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <AppInitializer />
    </StrictMode>,
);

void reportWebVitals();
